import React from 'react';
import { Box, Typography } from '@mui/material';
import UploadAccountLinks from './UploadAccountLinks';
import { COLOR } from './ui/tokens';

export const SAVE_NEEDS_ACCOUNT_MESSAGE = 'Register or log in to save your score.';

/**
 * End-of-game note when a manual run was not saved (from useManualRunRecorder).
 * Guests / logged-out players get the register / log-in buttons; other save
 * errors show the server's message.
 */
export default function ManualSaveNotice({ notice, color = COLOR.text }) {
    if (!notice || !notice.message) return null;
    return (
        <Box data-testid="manual-save-notice" role="status" sx={{ mt: 2, textAlign: 'center' }}>
            <Typography variant="body2" sx={{ color }}>
                {notice.message}
            </Typography>
            {notice.needsAccount ? <UploadAccountLinks color={color} /> : null}
        </Box>
    );
}
